import { Injectable } from '@angular/core';

@Injectable()
export class FechasService {

  constructor() { }

  /**
  * @desc Funcion para obtener la diferencia de dias entre dos fechas
  * @param {Date} fecha1
  * @param {Date} fecha2
  * @return {Number}
  */
  public obtenerDiferenciaDiasEntreDosFechas(fecha1: Date, fecha2: Date): number {
  	// Obtener 1 dia en milisegundos
	  let diaMs = 1000 * 60 * 60 * 24;

	  // Convertir ambas fechas a milisegundos
	  let fecha1Ms = fecha1.getTime();
	  let fecha2Ms = fecha2.getTime();

	  // Calcular la diferencia en milisegundos
	  let diffMs = fecha2Ms - fecha1Ms;
	    
	  // Convertir a dias y retornar el resulatdo
	  return Math.round(diffMs / diaMs);
  }

}



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/utils/fechas.service.ts